import React from 'react'

const TextAvatar = ({ name, color }) => {
  const initials = name
    .split(' ')
    .map((word) => word[0])
    .filter((_, index) => index < 2)
    .join('')
    .toUpperCase()

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '40px',
        height: '40px',
        minWidth: '40px',
        maxWidth: '40px',
        borderRadius: '50%',
        backgroundColor: color,
        color: 'white',
        fontWeight: 'bold',
        textTransform: 'uppercase',
      }}
    >
      {initials}
    </div>
  )
}

export default TextAvatar
